import React from 'react';
import { FileText, ShieldCheck, Building2, Phone, Mail } from 'lucide-react';
import { LEGAL, PHONE_DISPLAY, PHONE_TEL } from '../SiteLayout';

const Row = ({ label, value }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 12, padding: '10px 0', borderBottom: '1px solid #e2e8f0' }}>
    <span style={{ fontWeight: 600, color: '#334155' }}>{label}</span>
    <span style={{ color: '#0f172a' }}>{value}</span>
  </div>
);

export default function SiteLegal() {
  return (
    <main data-testid="site-legal">
      <div className="site-page-head">
        <div className="site-page-head-inner">
          <h1 className="site-reveal">Mentions légales</h1>
          <p className="site-reveal-1">
            Informations légales relatives au site www.cmlatrinite-matadi.com et à l&apos;établissement
            <strong> Centre Médical la Trinité SARLU</strong>.
          </p>
        </div>
      </div>

      {/* 1. Éditeur du site */}
      <section className="site-section">
        <span className="site-kicker"><Building2 size={14} style={{ verticalAlign: 'middle', marginRight: 6 }} />Éditeur du site</span>
        <h2>Identification de l&apos;établissement</h2>
        <div style={{ maxWidth: 820, marginTop: '1.5rem' }}>
          <Row label="Dénomination sociale" value={LEGAL.companyName} />
          <Row label="Forme juridique" value={LEGAL.formeJuridique} />
          <Row label="RCCM" value={LEGAL.rccm} />
          <Row label="Idnat" value={LEGAL.idnat} />
          <Row label="NIF" value={LEGAL.nif} />
          <Row label="Autorisation d'exercice" value={LEGAL.autorisationMSP} />
          <Row label="Siège social (Matadi)" value={LEGAL.addressMatadi} />
          <Row label="Extension (Boma)" value={LEGAL.addressBoma} />
          <Row label="Téléphone" value={<a href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a>} />
          <Row label="Email" value={<a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>} />
        </div>
      </section>

      {/* 2. Directeur de publication */}
      <div className="site-section-alt-wrap">
        <section className="site-section">
          <span className="site-kicker">Direction</span>
          <h2>Directeur de la publication</h2>
          <p style={{ color: 'var(--site-muted)', lineHeight: 1.75 }}>
            Le directeur de la publication du présent site est le <strong>Dr Jean Robert Boffendakini</strong>,
            Directeur Général et cofondateur du Centre Médical la Trinité SARLU.
          </p>
        </section>
      </div>

      {/* 3. Hébergement */}
      <section className="site-section">
        <span className="site-kicker">Hébergement</span>
        <h2>Hébergeur du site</h2>
        <p style={{ color: 'var(--site-muted)', lineHeight: 1.75 }}>
          Le site est hébergé sur l&apos;infrastructure <strong>Emergent Cloud</strong> — un environnement
          d&apos;hébergement Kubernetes managé opéré par Emergent Labs. Les informations précises relatives
          à l&apos;hébergeur peuvent être obtenues sur simple demande adressée à <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>.
        </p>
      </section>

      {/* 4. Propriété intellectuelle */}
      <div className="site-section-alt-wrap">
        <section className="site-section">
          <span className="site-kicker"><ShieldCheck size={14} style={{ verticalAlign: 'middle', marginRight: 6 }} />Propriété intellectuelle</span>
          <h2>Droits d&apos;auteur et contenu</h2>
          <p style={{ color: 'var(--site-muted)', lineHeight: 1.75 }}>
            L&apos;ensemble des contenus présents sur ce site (textes, images, logos, illustrations, vidéos,
            structure du site, code source) est la propriété exclusive du <strong>Centre Médical la Trinité SARLU</strong>
            ou de ses partenaires, et est protégé par les législations congolaise et internationale
            relatives au droit d&apos;auteur et à la propriété intellectuelle.
          </p>
          <p style={{ color: 'var(--site-muted)', lineHeight: 1.75, marginTop: '1rem' }}>
            Toute reproduction, représentation, modification, publication, transmission ou dénaturation,
            totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque
            support que ce soit, est interdite sans autorisation écrite préalable du Centre Médical la Trinité SARLU.
          </p>
        </section>
      </div>

      {/* 5. Données personnelles */}
      <section className="site-section">
        <span className="site-kicker">Données personnelles</span>
        <h2>Protection des données à caractère personnel</h2>
        <p style={{ color: 'var(--site-muted)', lineHeight: 1.75 }}>
          Le Centre Médical la Trinité SARLU accorde une importance primordiale à la protection des
          données personnelles de ses patients et des visiteurs de son site. Les informations recueillies
          via les formulaires, les prises de rendez-vous ou l&apos;espace patient font l&apos;objet d&apos;un
          traitement informatique destiné exclusivement à la gestion des soins, au suivi médical et à la
          relation avec les patients.
        </p>
        <p style={{ color: 'var(--site-muted)', lineHeight: 1.75, marginTop: '1rem' }}>
          Conformément à la législation applicable, chaque utilisateur dispose d&apos;un droit d&apos;accès,
          de rectification, de suppression, de limitation et d&apos;opposition concernant les données le
          concernant. Ces droits peuvent être exercés à tout moment auprès du Centre en écrivant à
          <a href={`mailto:${LEGAL.email}`}> {LEGAL.email}</a>.
        </p>
        <p style={{ color: 'var(--site-muted)', lineHeight: 1.75, marginTop: '1rem' }}>
          Les données médicales sont soumises au secret médical et ne sont accessibles qu&apos;aux
          professionnels de santé autorisés participant à votre prise en charge.
        </p>
      </section>

      {/* 6. Cookies */}
      <div className="site-section-alt-wrap">
        <section className="site-section">
          <span className="site-kicker">Cookies</span>
          <h2>Utilisation des cookies</h2>
          <p style={{ color: 'var(--site-muted)', lineHeight: 1.75 }}>
            Le site utilise uniquement des cookies techniques strictement nécessaires à son bon
            fonctionnement (authentification à l&apos;espace patient, préférences de navigation).
            Aucun cookie publicitaire ou de suivi comportemental n&apos;est déposé sans votre consentement.
          </p>
        </section>
      </div>

      {/* 7. Responsabilité */}
      <section className="site-section">
        <span className="site-kicker">Responsabilité</span>
        <h2>Limitation de responsabilité</h2>
        <p style={{ color: 'var(--site-muted)', lineHeight: 1.75 }}>
          Les informations médicales publiées sur ce site présentent un caractère général et informatif.
          Elles ne sauraient en aucun cas se substituer à une consultation médicale, à un diagnostic
          ou à un traitement prescrit par un professionnel de santé qualifié.
        </p>
        <p style={{ color: 'var(--site-muted)', lineHeight: 1.75, marginTop: '1rem' }}>
          Le Centre Médical la Trinité SARLU met tout en œuvre pour offrir aux utilisateurs des
          informations et des outils disponibles et vérifiés, mais ne saurait être tenu responsable
          des erreurs, d&apos;une indisponibilité des informations ou de la présence de virus sur son site.
        </p>
        <p style={{ color: 'var(--site-muted)', lineHeight: 1.75, marginTop: '1rem', padding: '1rem 1.25rem', background: '#fee2e2', borderLeft: '4px solid #dc2626', borderRadius: 6 }}>
          <strong>En cas d&apos;urgence médicale</strong>, ne vous appuyez pas sur les contenus du site :
          contactez immédiatement le Centre au <a href={`tel:${PHONE_TEL}`} style={{ color: '#991b1b', fontWeight: 700 }}>{PHONE_DISPLAY}</a> ou
          les services de secours compétents.
        </p>
      </section>

      {/* 8. Contact */}
      <div className="site-section-alt-wrap">
        <section className="site-section">
          <span className="site-kicker">Nous contacter</span>
          <h2>Pour toute question relative aux présentes mentions</h2>
          <p style={{ color: 'var(--site-muted)', lineHeight: 1.75 }}>
            Toute demande d&apos;information ou réclamation relative au site ou aux présentes mentions
            légales peut être adressée à&nbsp;:
          </p>
          <div style={{ marginTop: '1rem', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <a href={`tel:${PHONE_TEL}`} className="site-btn site-btn-outline"><Phone size={16} /> {PHONE_DISPLAY}</a>
            <a href={`mailto:${LEGAL.email}`} className="site-btn site-btn-outline"><Mail size={16} /> {LEGAL.email}</a>
          </div>
        </section>
      </div>

      <p style={{ textAlign: 'center', color: 'var(--site-muted)', fontSize: 12, padding: '2rem 1rem' }}>
        Version en vigueur au {(() => { const d = new Date(); return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`; })()}.
      </p>
    </main>
  );
}
